import { useEffect, useRef } from "react";
import { Box } from "@mui/material";
import { useContextContrato } from "src/Contexts/Lancamentos/Contrato/ContratosContext";

import { CardDadosEmpresaModern } from "./Components/CardDadosEmpresaModern";
import { UseGetContractById } from "./hooks/UseGetContractById";
import { CardDadosTitularModern } from "./Components/CardDadosTitularModern";
import { CardDadosPlanoModern } from "./Components/CardDadosPlanoModern";
import { CardDependentesModern } from "./Components/CardDependentesModern";
import { CardDadosComplementarModern } from "./Components/CardDadosComplementarModern";
import { CardDadosContatoModern } from "./Components/CardDadosContatoModern";
import { CardPropostaModern } from "./Components/CardPropostaModern";
import { CardDadosCriacaoModern } from "./Components/CardDadosCriacaoModern";

interface IContract {
  idContract: string;
}

export const Contract = ({ idContract: id }: IContract) => {
  const { valueContractInternal } = useContextContrato();
  const { handleGet } = UseGetContractById();
  const printRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (id) handleGet(id);
  }, [id]);

  if (!valueContractInternal) return null;

  return (
    <Box
      ref={printRef}
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: { xs: 2, md: 3 },
        p: { xs: 1, sm: 2, md: 3 },
        minHeight: "100vh",
        borderRadius: "16px",
      }}
    >
      <CardPropostaModern idContract={id} />

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", lg: "1fr 1fr" },
          gap: { xs: 2, md: 3 },
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: { xs: 2, md: 3 } }}>
          <CardDadosPlanoModern />
          <CardDadosTitularModern />
          <CardDadosEmpresaModern />
          <CardDependentesModern />
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column", gap: { xs: 2, md: 3 } }}>
          <CardDadosComplementarModern />
          <CardDadosContatoModern />
        </Box>
      </Box>

      <CardDadosCriacaoModern />
    </Box>
  );
};
